import { t } from "../../hooks/useAppTranslation";
import { Formik, Form } from "formik";
import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Checkbox from "@mui/material/Checkbox";
import { FormControlLabel } from "@material-ui/core";
import { IDictionary } from "../ExternalControl/ExternalControlContainer";

type Props = {
  handleNewDictValue(e: React.MouseEvent): void;
  handleChangeDictValue(kind: IDictionary, checked: boolean): Promise<void>;
  data: IDictionary[];
};

export const DictsListForm: React.FC<Props> = ({
  handleNewDictValue,
  handleChangeDictValue,
  data,
}) => {
  return (
    <Formik
      enableReinitialize={true}
      onSubmit={(values) => {
        console.log(values);
      }}
      initialValues={{}}
    >
      {({ handleSubmit }) => {
        return (
          <Form>
            <List>
              {data?.map((dict: IDictionary) => {
                const labelId = `checkbox-list-secondary-label-${dict.entryId}`;
                return (
                  <div key={dict.entryId} className='two-column'>
                    <ListItem>
                      <FormControlLabel
                        label={dict.description}
                        control={
                          <Checkbox
                            id={dict.abbrev}
                            name={dict.abbrev}
                            checked={dict.active}
                            onChange={(e) => {
                              handleChangeDictValue(dict, e.target.checked);
                            }}
                            inputProps={{ "aria-labelledby": labelId }}
                          />
                        }
                      />
                    </ListItem>
                  </div>
                );
              })}
              <div key='button-add' className='two-column'>
                <ListItem>
                  <button
                    type='button'
                    className='btn save-btn uppercase'
                    onClick={handleNewDictValue}
                  >
                    + {t('g-add-new')}
                    <span className='sr-only'> {t('external-controls-control-kind')}</span>
                  </button>
                </ListItem>
              </div>
            </List>
          </Form>
        );
      }}
    </Formik>
  );
};
